import { Icon } from "./Icon";

export function ErrorAlert({ message }) {
  if (!message) return null;
  return (
    <div className="alert" role="alert">
      <Icon name="alert" size={18} />
      <span>{message}</span>
    </div>
  );
}

export function Loading({ label }) {
  return <div className="state" role="status">{label}</div>;
}

// Distinguishes "nothing here" from "nothing matches" so an empty result is
// never just a blank region.
export function Empty({ title, detail, action }) {
  return (
    <div className="state">
      <p className="state__title">{title}</p>
      {detail && <p className="state__detail">{detail}</p>}
      {action && <div className="state__actions">{action}</div>}
    </div>
  );
}

export function Field({ id, label, grow, children }) {
  return (
    <div className={`field${grow ? " field--grow" : ""}`}>
      <label className="field__label" htmlFor={id}>{label}</label>
      {children}
    </div>
  );
}
